<template>
    <div class="w-full relative border-1 rounded-2xl px-[30px] py-[35px] border-gray-300">
        {{ actionButtons }}
        <div
            class="w-full flex mobile:flex-col laptop:flex-row laptop:justify-end laptop:items-center mobile:gap-6 laptop:gap-2 mobile:px-1.5 laptop:px-2.5 absolute -top-[21px] right-0">
            <template v-for="(action, index) in actionButtons.slice(0, buttonShowCount)" :key="index">
                <!-- this button for laptop/desktop -->
                <button v-if="isLaptop" type="button"
                    class="group flex items-center rounded-full gap-2 py-1.5 pl-3 pr-2 font-roboto font-normal text-[18px] h-[40px] transition duration-300 mobile:text-[#fff] hover:!text-[#fff] border-1 laptop:bg-[#fff]"
                    :style="{
                        color: action.color,
                        borderColor: action.color
                    }" @mouseover="isLaptop && ($event.currentTarget.style.backgroundColor = action.color)"
                    @mouseleave="isLaptop && ($event.currentTarget.style.backgroundColor = '#fff')">
                    {{ action.title }}
                    <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                        class="h-[24px] w-[24px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:!bg-white mobile:bg-white relative"
                        :style="{
                            backgroundColor: action.color
                        }">
                        <img :src="getImageSrc(action.image)" alt="icon"
                            class="w-[16px] h-[16px] transition mobile:hidden laptop:block laptop:group-hover:hidden">

                        <div class="w-[16px] h-[16px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
                            :style="{
                                WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                                mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                                backgroundColor: action.color
                            }" />
                    </span>
                </button>
                <!-- this button for tablet/mobile -->
                <button v-else type="button"
                    class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] transition duration-300 text-[#fff]"
                    :style="{
                        backgroundColor: action.color
                    }">
                    {{ action.title }}
                    <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                        class="w-[26px] h-[26px] transition duration-300 flex justify-center items-center rounded-full relative bg-white">
                        <div class="w-[20px] h-[20px]  absolute transition duration-300 block" :style="{
                            WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                            mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                            backgroundColor: action.color
                        }" />
                    </span>
                </button>
            </template>
            <div class="withdropdown">
                <div class="table-dropdown-container">
                    <button class="z-0 relative w-[40px] h-[40px] rounded-full flex items-center justify-center
                    focus:outline-none focus:ring-0 focus:shadow-none dropdown-toggle after:!hidden table-dropdown-btn"
                        type="button" aria-haspopup="true" aria-expanded="false" @click.stop="toggleDropdown($event)">
                        <img src="../../../assets/images/actionIcon.png" alt="Icon">
                    </button>

                    <div ref="dropdownMenus"
                        class="table-dropdown-menu dropdown-menu !shadow-custom !border-0 !h-max !p-1 !z-50 !right-0 !left-auto !transform-none !bg-customWhite">
                        <ul class="p-0 mb-0 rounded-lg !z-50 !bg-customWhite">
                            <li v-for="(action, index) in getActions" :key="index"
                                class="dropdown-item border-b p-0 last-of-type:border-none rounded-lg border-customGray active:!bg-transparent">
                                <a
                                    class="cursor-pointer block leading-normal text-[14px] px-2 py-1 rounded-lg text-[#333] relative z-10 transition-all hover:bg-[#FE5000] hover:!text-customWhite">
                                    {{ action }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex gap-[30px]">
            <div class="w-full">
                <!-- {{ apptDetail }} -->
                <div class="w-full shadow-[0px_0px_15px_-2px_#ccc] rounded-[20px] p-[20px] !pt-[10px] bg-white">
                    <!-- details header -->
                    <div class="flex justify-between items-center gap-1 pb-[20px]">
                        <div class="flex justify-start items-center gap-1">
                            <div class="w-[8px] h-[8px] rounded-full bg-purple-100" />
                            <div class="w-[35px] h-[8px] rounded-full bg-purple-100" />
                            <p class="text-[20px] font-bold font-roboto pl-2 m-0 text-[#9336B4]">
                                Details
                            </p>
                        </div>
                        <div v-if="apptDetail.depp_schedule?.company_logo"
                            class="flex justify-center items-center w-[50px] h-[50px] rounded-full bg-[#EFEFEF]">
                            <img :src="apptDetail.depp_schedule?.company_logo" alt="logo"
                                class="w-[26px] h-[26px] object-contain">
                        </div>
                    </div>
                    <!-- heading box -->
                    <div
                        class="flex justify-between items-center gap-1 pl-[10px] p-[5px] shadow-[0px_0px_15px_-2px_#ccc] rounded-[5px]">
                        <h4 class="text-[16px] font-medium font-roboto m-0 text-[#5E366A]">
                            {{ apptDetail.title }}
                        </h4>
                        <div class="flex items-center justify-end gap-2.5">
                            <h4 class="text-[16px] font-medium font-roboto m-0 text-[#333333]">
                                Appointment Status:
                            </h4>
                            <span
                                class="text-[14px] font-medium font-roboto py-[4px] px-[18px] rounded-[5px] border-1 border-[#14B8A6] bg-[#14B8A6]/5 text-[#14B8A6]">{{
                                    apptDetail.status_text }}</span>
                        </div>
                    </div>
                    <!-- details -->
                    <div class="grid grid-cols-3 gap-y-4 mt-[20px]">
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Appointment
                                Title:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.title }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Appointment ID:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.id }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Quote ID:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ Number(apptDetail.manual_quote?.id) > 0 ? apptDetail.manual_quote.id : "-" }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Consumer Name:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.consumer?.full_name }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Phone Number:</span>
                            <a v-if="apptDetail.consumer?.phone"
                                class="w-fit block underline m-0 text-[16px] font-roboto font-medium transition-all duration-300 text-[#333333] hover:text-[#FE5000]"
                                :href="'tel:' + apptDetail.consumer.phone">
                                {{ apptDetail.consumer.phone }}
                            </a>
                            <p v-else class="m-0 text-[16px] font-roboto font-medium text-[#333333]">-</p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Consumer email:</span>
                            <a v-if="apptDetail.consumer?.email"
                                class="w-fit block underline m-0 text-[16px] font-roboto font-medium transition-all duration-300 text-[#333333] hover:text-[#FE5000]"
                                :href="'mailto:' + apptDetail.consumer.email">
                                {{ apptDetail.consumer.email }}
                            </a>
                            <p v-else class="m-0 text-[16px] font-roboto font-medium text-[#333333]">-</p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Visit Schedule:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ convertTimsStampToDate(apptDetail.visit_date) }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Trade Type:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.trade_type }}
                            </p>
                        </div>
                        <div>
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Service:</span>
                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.service_type_text }}
                            </p>
                        </div>
                        <div class="col-span-3">
                            <span class="text-[14px] font-roboto font-normal text-[#EA8A8A]">Address:</span>

                            <p class="text-[16px] font-roboto font-normal mb-0 text-[#333333]">
                                {{ apptDetail.address }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="min-w-[350px]">
                <noteBox />
            </div>
        </div>
    </div>
    <!-- <div id="exampleModal" ref="tradecall" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <TradeCallDialog @event="TradeCallBack" />
      </div>
    </div> -->
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import noteBox from '../../../components/workOrder/appointments/noteBox.vue';
import moment from "moment";
import { disableScroll, enableScroll } from "../../../helpers/scrollHelper";
import { Modal } from "bootstrap";

export default {
    components: {
        noteBox,
    },

    data() {
        return {
            isStartQuote: false,
            originlat: 0,
            originlng: 0,
            actionButtons: [],
            center: {
                lat: 0,
                lng: 0,
            },
            markers: [
                {
                    position: {
                        lat: 0,
                        lng: 0,
                    },
                }, // Along list of clusters
            ],
            isNotesOpen: false,
            serviceId: null,
            isLaptop: window.innerWidth >= 1024
        };
    },
    computed: {
        ...mapGetters([
            "apptDetail",
            "cancelAppointment",
            "getAppointmentDetails",
            "setAppointmentAction",
            "saveApptointmentActionEnroute",
            "saveApptointmentActionArrived",
            "saveApptointmentCreatelObject",
            "services",
            "bookingConverted",
        ]),
        buttonShowCount() {
            return window.innerWidth <= 768 ? 2 : 3
        }
    },

    watch: {
        apptDetail: function () {
            let user = JSON.parse(localStorage.getItem('user'));
            let user_id = user.user.user_id;

            if (this.apptDetail.technician?.user_id != user_id) {

                this.$router.push({
                    name: 'NotFound',
                });

            } else {
                this.markers[0].position.lat = this.apptDetail.lat;
                this.markers[0].position.lng = this.apptDetail.lng;

                this.center.lat = this.apptDetail.lat;
                this.center.lng = this.apptDetail.lng;

                this.actionButtons = [];
                if (this.apptDetail.status == 0) {
                    this.actionButtons.push({ title: 'On My Way', image: 'on-my-way.png', color: '#FC819E' });
                    // this.actionButtons.push({ title: 'Internal Notes', image: 'internal-notes.png', color: '#F67280' });
                } else if (this.apptDetail.status == 1) {
                    this.actionButtons.push({ title: 'Mark As Arrived', image: 'mark-as-arrived.png', color: '#168EFF' });
                    // this.actionButtons.push({ title: 'Internal Notes', image: 'internal-notes.png', color: '#F67280' });
                } else if (this.apptDetail.status == 2) {
                    this.actionButtons.push({ title: 'Start Quote', image: 'start-quote.png', color: '#F67280' });
                    // this.actionButtons.push({ title: 'Internal Notes', image: 'internal-notes.png', color: '#F67280' });
                } else if (this.apptDetail.status == 7) {
                    //cancel status
                } else {
                    if (this.apptDetail.flow_type == "sar") {
                        if (this.apptDetail.booking.status + "" == "4") {
                            this.serviceUpdateCall(this.apptDetail.booking.id, "sar")
                            this.$router.push({
                                path: `/select/unit/${this.apptDetail.booking.id}`,
                                query: {
                                    is_from_mobile:
                                        Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0,
                                },
                            });
                        } else {
                            this.$router.push({
                                path: `/job/detail/${this.apptDetail.booking.id}`,
                                query: {
                                    is_from_mobile:
                                        Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0,
                                },
                            });
                        }
                    } else {
                        if (this.isStartQuote) {
                            this.serviceUpdateCall(this.apptDetail.manual_quote.id, "iq")
                            this.$router.push({
                                path: `/quote/detail/${this.apptDetail.manual_quote.id}`,
                                query: {
                                    is_edit: 1,
                                },
                            });
                        } else {
                            this.$router.push({
                                path: `/quote/detail/${this.apptDetail.manual_quote.id}`,
                            });
                        }
                    }
                }
            }
        },
    },

    mounted() {

        this.getAppointmenttDetails();
        window.addEventListener('scroll', this.hideDropdownOnScroll, true);
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', () => {
            this.isLaptop = window.innerWidth >= 1024;
        });
    },
    beforeMount() {
        window.removeEventListener('scroll', this.hideDropdownOnScroll, true);
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        ...mapActions([
            "getAppointmentDetailsAPICall",
            "appointmentCancel",
            "markAsEnrouteAPICall",
            "markAsArrivedAPICall",
            "appointmentCreate",
            "setCommponent",
            "getServices",
            "convretToBooking",
            "apptServiceUpdate"
        ]),

        getAppointmenttDetails() {
            this.getAppointmentDetailsAPICall({
                id: this.$route.params.id,
            });
        },
        hideDropdownOnScroll() {
            document.querySelectorAll('.table-dropdown-menu.show').forEach(menu => {
                menu.classList.remove('show');
            });
        },

        toggleDropdown(event, index) {
            const dropdownMenu = event.currentTarget.nextElementSibling;
            document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
                if (menu !== dropdownMenu) {
                    menu.classList.remove('show');
                }
            });
            dropdownMenu.classList.toggle('show');
        },

        handleClickOutside(event) {
            const dropdowns = document.querySelectorAll('.table-dropdown-container');
            dropdowns.forEach(dropdown => {
                if (!dropdown.contains(event.target)) {
                    const menu = dropdown.querySelector('.table-dropdown-menu');
                    if (menu && menu.classList.contains('show')) {
                        menu.classList.remove('show');
                    }
                }
            });
        },
        convertTimsStampToDate(val) {
            return moment.unix(val).format("MM/DD/YYYY - hh:mm A");
        },
        startQuoteCall() {
            this.$dialog.show({
                title: "Status Change",
                text: "Are you sure you want to start this quote?",
                onConfirm: () => {
                    if (this.apptDetail.flow_type == "sar") {
                        this.convertToBooking();
                    } else {
                        this.startQuote();
                    }
                },
            });
        },

        convertToBooking() {
            this.convretToBooking({
                appointment_id: this.$route.params.id,
                service_id: this.apptDetail.service_id,
            });
        },

        serviceTypeCallBack(data, check) {
            this.serviceId = check
            enableScroll()
            if (data == "close") {
                this.modal.hide();
            } else if (data == "confirm") {
                this.modal.hide();
                this.startQuoteCall()
            }
        },

        openGoogleMaps() {
            const desLat = this.apptDetail.lat ?? 0;
            const desLng = this.apptDetail.lng ?? 0;
            const googleMapsUrl = `https://maps.google.com/?q=${desLat},${desLng}`;

            // Check if the Google Maps app is installed
            if (navigator.platform.indexOf("Win") > -1) {
                // Windows platform, open in a new window
                window.open(googleMapsUrl, "_blank");
            } else {
                // Non-Windows platform, try to open in the maps app
                window.location.href = googleMapsUrl;
                //  window.location.href =`geo:0,0?q=${encodeURIComponent(destination)}`;
            }
        },

        serviceUpdateCall(quote_id, quote_type) {
            if (this.apptDetail.depp_schedule.can_service_type_update == '1') {
                this.apptServiceUpdate({
                    "quote_id": quote_id,
                    "quote_type": quote_type,
                    "service_id": this.serviceId
                })
            }
        },

        markAsEnroute() {
            this.$dialog.show({
                title: "Status Change",
                text: "Are you sure you want to mark yourself enroute?",
                // image: "pop-req-img.png",
                // we are passing callback method for our confirm button
                onConfirm: () => {
                    this.markAsEnrouteAPICall({
                        appointment_id: this.$route.params.id,
                    });
                },
            });
        },

        markAsArrived() {
            this.$dialog.show({
                title: "Status Change",
                text: "Are you sure you want to mark yourself as Arrived?",
                // image: "pop-req-img.png",
                // we are passing callback method for our confirm button
                onConfirm: () => {
                    this.markAsArrivedAPICall({
                        appointment_id: this.$route.params.id,
                    });
                },
            });
        },

        TradeCallBack(data, waiveTradeCall) {
            enableScroll()
            if (data == "close") {
                this.modal.hide();
            } else if (data == "confirm") {
                this.modal.hide();
                this.isStartQuote = true;
                let params = {
                    appointment_id: this.$route.params.id,
                }

                if (waiveTradeCall == 1) {
                    params['waive_trade_call_fee'] = 1
                }
                else {
                    params['waive_trade_call_fee'] = 0
                }

                this.appointmentCreate(params);
            }
        },

        startQuote() {
            this.isStartQuote = true;
            this.appointmentCreate({
                appointment_id: this.$route.params.id,
            });
        },

        convertNotesTimsStampToDate(val) {
            return moment.unix(val).format("hh:mm a MM/DD/YYYY");
        },

        actionButtonClicked(action) {
            if (action == "On My Way") {
                this.markAsEnroute();
            } else if (action == "Internal Notes") {
                this.openNotesModal();
            } else if (action == "Mark As Arrived") {
                this.markAsArrived();
            } else if (action == "Start Quote") {
                if (this.apptDetail.flow_type == "uq" && this.apptDetail.depp_schedule.is_tradecall_fee_applicable == 1) {
                    disableScroll()
                    this.modal = new Modal(this.$refs.tradecall);
                    this.modal.show();
                } else {
                    if (this.apptDetail.depp_schedule.can_service_type_update == '1') {
                        this.getServices();
                    } else {
                        this.startQuoteCall()
                    }
                }
            }
        },
        getImageSrc(imageName) {
            try {
                return require(`@/assets/images/buttons-icons/${imageName}`);
            } catch (error) {
                return ''; // ya default image
            }
        },
    },
};
</script>